import { Category } from '@v2/shared/lib/types';
import { MenuPanel } from '@v2/brands/discountmags/Layouts/Full/Navigation';
import useToggle from '@v2/shared/lib/useToggle';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';

import CategoriesDialog from './CategoriesDialog';
import CategoryCard from './CategoryCard';

type Props = {
  categories: Category[];
  featuredCategories: Category[];
  title: string;
  closeMainMenu: () => void;
};

export default function CategoriesPanel({ categories, featuredCategories, title, closeMainMenu }: Props) {
  const { isOpen: showCategoriesMenu, toggle: toggleCategories, close: closeCategories } = useToggle();

  return (
    <>
      <MenuPanel>
        <MenuPanel.Title
          title={title}
          showButton
          button={{ text: 'View all', icon: faLongArrowRight }}
          onClick={toggleCategories}
        />
        <div className="grid grid-cols-4 gap-x-4 gap-y-2">
          {featuredCategories.slice(0, 8).map((category) => (
            <CategoryCard key={category.id} category={category} onClick={closeMainMenu} />
          ))}
        </div>
      </MenuPanel>
      <CategoriesDialog
        isOpen={showCategoriesMenu}
        toggle={toggleCategories}
        close={closeCategories}
        closeMenu={closeMainMenu}
        categories={categories}
      />
    </>
  );
}
